export default function LoadingOverlay() {
  return (
    <div id="loading" />
  )
}
